<script>
import videojs from 'video.js'
import zh from 'video.js/dist/lang/zh-CN.json'

videojs.addLanguage('zh', zh)

export default {
  name: "YJVideo",
  props: {
    src: {
      default: "",
    },
    option: {}
  },
  watch: {
    src(newValue, oldValue) {
      this.src = newValue;
      this.player.src(this.src)
    }
  },
  data() {
    return {
      player: null
    }
  },
  methods: {},
  mounted() {
    if (this.src.startsWith("blob:")) {
      this.$refs.video.src = this.src;
    } else {
      this.player = videojs(this.$refs.video, {
        controls: true,
        language: 'zh',
        ...this.option
      });
      this.player.src(this.src);
    }
  },
  beforeDestroy() {
    this.player.dispose();
  }
};

</script>

<template>
  <video ref="video" controls class="video-js vjs-big-play-centered">
  </video>
</template>

<style scoped lang="scss">
.YJVideo {
  //.video-js {
  //  width: 100%;
  //  height: 100%;
  //}
}

</style>